export interface JiraAnnotations {
  projectKey?: string;
  component?: string;
  label?: string;
  team?: string;
  allIssuesJql?: string;
}

export function buildJql(annotations: JiraAnnotations): string {
  if (annotations.allIssuesJql) {
    return annotations.allIssuesJql;
  }

  const parts: string[] = [];

  if (annotations.projectKey) {
    parts.push(`project = "${annotations.projectKey}"`);
  }
  if (annotations.component) {
    parts.push(`component = "${annotations.component}"`);
  }
  if (annotations.label) {
    parts.push(`labels = "${annotations.label}"`);
  }
  if (annotations.team) {
    parts.push(`"Team" = "${annotations.team}"`);
  }

  return parts.length > 0
    ? `${parts.join(' AND ')} ORDER BY updated DESC`
    : 'ORDER BY updated DESC';
}
